// ?use_estimated_size_snap_range=N (2026-10-05) — how far, in whole inches,
// the pinch may step from an ESTIMATED size (the GLB's, when the payload
// carries none). Default 3; 0 disables the pinch on an estimated size. A
// payload size is never affected.

export const ESTIMATED_SIZE_SNAP_RANGE_PARAM = 'use_estimated_size_snap_range'
export const DEFAULT_ESTIMATED_SIZE_SNAP_RANGE_IN = 3

export function estimatedSizeSnapRange(params: URLSearchParams): number {
  const raw = params.get(ESTIMATED_SIZE_SNAP_RANGE_PARAM)
  if (raw == null || raw.trim() === '') return DEFAULT_ESTIMATED_SIZE_SNAP_RANGE_IN
  const n = Number(raw)
  return Number.isInteger(n) && n >= 0 ? n : DEFAULT_ESTIMATED_SIZE_SNAP_RANGE_IN
}
